import { QualityType } from '@talend/design-system';

import { QualityBar } from './QualityBar.component';

export { QualityBar, QualityType };
